import {Grid} from '@material-ui/core';
import {useQuoteField} from 'Quoting/components/hooks/useHandleQuoteFieldChange';
import {FormRowGrid, GridRowProps} from 'Quoting/components/shared/GridRow';
import {ConditionalSection, QuoteFormConditionalSection} from 'Quoting/components/shared/QuoteFormConditionalSection';
import {QuoteFormElement} from 'Quoting/components/shared/QuoteFormElement';
import {FormWrapper} from 'Quoting/components/shared/QuoteFormWrapper';
import {Map as ImmutableMap} from 'immutable';
import React from 'react';
import {useSelector} from 'react-redux';
import {ReducerState} from 'rootReducer';
import {unitsOptions} from '../../PlanTemplates/ACC/benefitDefaults';
import {formatCurrencyValue} from './ACCBenefits';
import {deathandDismembermentPath} from './PropertyPaths/propertyPathACC';

export const AccidentalDeathAndDismembermentUnits = () => {
  const {selectedPlan} = useSelector((state: ReducerState) => state.quoteForm);
  const {getQuoteFieldValue} = useQuoteField();
  const propertyPaths = deathandDismembermentPath(selectedPlan?.planIndex ?? 0);

  const rows: GridRowProps[] = [
    {
      rowProps: {key: 'acc-death-dismemberment-row-1'},
      items: [
        {
          key: propertyPaths.unitsOfAccidentalDeathAndDismemberment,
          element: (
            <QuoteFormElement
              elementType="Select"
              type="number"
              options={unitsOptions}
              label="Units"
              value={getQuoteFieldValue<number>(propertyPaths.unitsOfAccidentalDeathAndDismemberment)}
              required
              disabled
              id={propertyPaths.unitsOfAccidentalDeathAndDismemberment}
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
      ],
    },
  ];

  return <FormRowGrid rows={rows} />;
};

export const AccidentalDeath = () => {
  const {selectedPlan} = useSelector((state: ReducerState) => state.quoteForm);
  const {getQuoteFieldValue} = useQuoteField();
  const propertyPaths = deathandDismembermentPath(selectedPlan?.planIndex ?? 0);

  const rows: GridRowProps[] = [
    {
      rowProps: {key: 'acc-death-dismemberment-row-1'},
      items: [
        {
          key: propertyPaths.accidentalDeathDetails.incurralPeriod,
          element: (
            <QuoteFormElement
              elementType="Text"
              type="number"
              label="Incurral Period (Days)"
              value={getQuoteFieldValue(propertyPaths.accidentalDeathDetails.incurralPeriod)}
              id={propertyPaths.accidentalDeathDetails.incurralPeriod}
              required
              disabled
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
        {
          key: propertyPaths.accidentalDeathDetails.benefitAmount,
          element: (
            <QuoteFormElement
              elementType="Text"
              label="Benefit Amount"
              value={formatCurrencyValue(getQuoteFieldValue(propertyPaths.accidentalDeathDetails.benefitAmount))}
              id={propertyPaths.accidentalDeathDetails.benefitAmount}
              required
              disabled
              adornment="money"
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
      ],
    },
  ];
  return <FormRowGrid rows={rows} />;
};

export const AccidentalDeathCommonCarrier = () => {
  const {selectedPlan} = useSelector((state: ReducerState) => state.quoteForm);
  const {getQuoteFieldValue} = useQuoteField();
  const propertyPaths = deathandDismembermentPath(selectedPlan?.planIndex ?? 0);

  const rows: GridRowProps[] = [
    {
      rowProps: {key: 'acc-death-dismemberment-row-1'},
      items: [
        {
          key: propertyPaths.accidentalDeathCommonCarrierDetails.incurralPeriod,
          element: (
            <QuoteFormElement
              elementType="Text"
              type="number"
              label="Incurral Period (Days)"
              value={getQuoteFieldValue(propertyPaths.accidentalDeathCommonCarrierDetails.incurralPeriod)}
              id={propertyPaths.accidentalDeathCommonCarrierDetails.incurralPeriod}
              required
              disabled
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
        {
          key: propertyPaths.accidentalDeathCommonCarrierDetails.benefitAmount,
          element: (
            <QuoteFormElement
              elementType="Text"
              label="Benefit Amount"
              value={formatCurrencyValue(
                getQuoteFieldValue(propertyPaths.accidentalDeathCommonCarrierDetails.benefitAmount)
              )}
              id={propertyPaths.accidentalDeathCommonCarrierDetails.benefitAmount}
              required
              disabled
              adornment="money"
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
      ],
    },
  ];
  return <FormRowGrid rows={rows} />;
};

export const AccidentalDismembermemt = () => {
  const {selectedPlan} = useSelector((state: ReducerState) => state.quoteForm);
  const {getQuoteFieldValue} = useQuoteField();
  const propertyPaths = deathandDismembermentPath(selectedPlan?.planIndex ?? 0);
  const situsStateCd = getQuoteFieldValue<string>('riskStateCd');

  const rows: GridRowProps[] = [
    {
      rowProps: {key: 'acc-death-dismemberment-accidentalDismemberment-row-1'},
      items: [
        {
          key: propertyPaths.accidentalDismembermentDetails.incurralPeriod,
          element: (
            <QuoteFormElement
              elementType="Text"
              type="number"
              label="Incurral Period (Days)"
              value={getQuoteFieldValue(propertyPaths.accidentalDismembermentDetails.incurralPeriod)}
              id={propertyPaths.accidentalDismembermentDetails.incurralPeriod}
              required
              disabled
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
        {
          key: propertyPaths.accidentalDismembermentDetails.bothArmsOrHandsLossAmount,
          element: (
            <QuoteFormElement
              elementType="Text"
              label="Loss of Both Arms or Hands"
              value={formatCurrencyValue(
                getQuoteFieldValue(propertyPaths.accidentalDismembermentDetails.bothArmsOrHandsLossAmount)
              )}
              id={propertyPaths.accidentalDismembermentDetails.bothArmsOrHandsLossAmount}
              required
              disabled
              adornment="money"
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
      ],
    },
    {
      rowProps: {key: 'acc-death-dismemberment-accidentalDismemberment-row-2'},
      items: [
        {
          key: propertyPaths.accidentalDismembermentDetails.bothLegsOrFeetLossAmount,
          element: (
            <QuoteFormElement
              elementType="Text"
              label="Loss of Both Legs or Feet"
              value={formatCurrencyValue(
                getQuoteFieldValue(propertyPaths.accidentalDismembermentDetails.bothLegsOrFeetLossAmount)
              )}
              id={propertyPaths.accidentalDismembermentDetails.bothLegsOrFeetLossAmount}
              required
              disabled
              adornment="money"
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
        {
          key: propertyPaths.accidentalDismembermentDetails.oneHandOrArmAndOneLegOrFootLossAmount,
          element: (
            <QuoteFormElement
              elementType="Text"
              label="Loss of One Hand or Arm and One Leg or Foot"
              value={formatCurrencyValue(
                getQuoteFieldValue(propertyPaths.accidentalDismembermentDetails.oneHandOrArmAndOneLegOrFootLossAmount)
              )}
              id={propertyPaths.accidentalDismembermentDetails.oneHandOrArmAndOneLegOrFootLossAmount}
              required
              disabled
              adornment="money"
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
      ],
    },
    {
      rowProps: {key: 'acc-death-dismemberment-accidentalDismemberment-row-3'},
      items: [
        {
          key: propertyPaths.accidentalDismembermentDetails.armOrHandLossAmount,
          element: (
            <QuoteFormElement
              elementType="Text"
              label="Loss of Arm or Hand"
              value={formatCurrencyValue(
                getQuoteFieldValue(propertyPaths.accidentalDismembermentDetails.armOrHandLossAmount)
              )}
              id={propertyPaths.accidentalDismembermentDetails.armOrHandLossAmount}
              adornment="money"
              required
              disabled
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
        {
          key: propertyPaths.accidentalDismembermentDetails.legOrFootLossAmount,
          element: (
            <QuoteFormElement
              elementType="Text"
              label="Loss of Leg or Foot"
              value={formatCurrencyValue(
                getQuoteFieldValue(propertyPaths.accidentalDismembermentDetails.legOrFootLossAmount)
              )}
              id={propertyPaths.accidentalDismembermentDetails.legOrFootLossAmount}
              required
              disabled
              adornment="money"
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
      ],
    },
    {
      rowProps: {key: 'acc-death-dismemberment-accidentalDismemberment-row-4'},
      items: [
        {
          key: propertyPaths.accidentalDismembermentDetails.oneOrMoreFingersLossAmount,
          element: (
            <QuoteFormElement
              elementType="Text"
              label={situsStateCd === 'NH' ? 'Loss of Finger(s)/Per Finger' : 'Loss of One or More Fingers'}
              value={formatCurrencyValue(
                getQuoteFieldValue(propertyPaths.accidentalDismembermentDetails.oneOrMoreFingersLossAmount)
              )}
              id={propertyPaths.accidentalDismembermentDetails.oneOrMoreFingersLossAmount}
              required
              disabled
              adornment="money"
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
        {
          key: propertyPaths.accidentalDismembermentDetails.oneOrMoreToesLossAmount,
          element: (
            <QuoteFormElement
              elementType="Text"
              label={situsStateCd === 'NH' ? 'Loss of Toe(s)/Per Toe' : 'Loss of One or More Toes'}
              value={formatCurrencyValue(
                getQuoteFieldValue(propertyPaths.accidentalDismembermentDetails.oneOrMoreToesLossAmount)
              )}
              id={propertyPaths.accidentalDismembermentDetails.oneOrMoreToesLossAmount}
              required
              disabled
              adornment="money"
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
      ],
    },
    {
      rowProps: {key: 'acc-death-dismemberment-accidentalDismemberment-row-5'},
      items: [
        {
          key: propertyPaths.accidentalDismembermentDetails.maximumBenefitAmount,
          element: (
            <QuoteFormElement
              elementType="Text"
              label="Maximum Benefit Amount"
              value={formatCurrencyValue(
                getQuoteFieldValue(propertyPaths.accidentalDismembermentDetails.maximumBenefitAmount)
              )}
              id={propertyPaths.accidentalDismembermentDetails.maximumBenefitAmount}
              required
              disabled
              adornment="money"
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
        {
          key: propertyPaths.accidentalDismembermentDetails.maxBenefitNumber,
          element: (
            <QuoteFormElement
              elementType="SelectV2"
              dropdownVariant="AttributeValue"
              searchKey="ACCAccidentalDismembermentBenefit.maxBenefitNumber"
              label="Number of Times Maximum Benefit is Payable per Time Period"
              value={getQuoteFieldValue(propertyPaths.accidentalDismembermentDetails.maxBenefitNumber)}
              id={propertyPaths.accidentalDismembermentDetails.maxBenefitNumber}
              required
              disabled
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
      ],
    },
    {
      rowProps: {key: 'acc-death-dismemberment-accidentalDismemberment-row-6'},
      items: [
        {
          key: propertyPaths.accidentalDismembermentDetails.timePeriodCd,
          element: (
            <QuoteFormElement
              elementType="SelectV2"
              dropdownVariant="AttributeValue"
              searchKey="ACCAccidentalDismembermentBenefit.timePeriodCd"
              label="Time Period"
              value={getQuoteFieldValue(propertyPaths.accidentalDismembermentDetails.timePeriodCd)}
              id={propertyPaths.accidentalDismembermentDetails.timePeriodCd}
              required
              disabled
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
      ],
    },
  ];
  return <FormRowGrid rows={rows} />;
};

export const FunctionalLoss = () => {
  const {selectedPlan} = useSelector((state: ReducerState) => state.quoteForm);
  const {getQuoteFieldValue} = useQuoteField();
  const propertyPaths = deathandDismembermentPath(selectedPlan?.planIndex ?? 0);

  const isGVA6Plan =
    getQuoteFieldValue<ImmutableMap<string, any>>(`benefitPackagingDetail.plans[${selectedPlan?.planIndex ?? 0}]`)?.get(
      'planCd'
    ) == 'GVA6';

  const rows: GridRowProps[] = [
    {
      rowProps: {key: 'acc-death-dismemberment-functional-loss-row-1'},
      items: [
        {
          key: propertyPaths.functionalLossDetails.incurralPeriod,
          element: (
            <QuoteFormElement
              elementType="Text"
              type="number"
              label="Incurral Period (Days)"
              value={getQuoteFieldValue(propertyPaths.functionalLossDetails.incurralPeriod)}
              id={propertyPaths.functionalLossDetails.incurralPeriod}
              required
              disabled
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
        {
          key: propertyPaths.functionalLossDetails.minimumDuration,
          element: (
            <QuoteFormElement
              elementType="Text"
              type="number"
              label="Minimum Duration (Days)"
              value={getQuoteFieldValue(propertyPaths.functionalLossDetails.minimumDuration)}
              id={propertyPaths.functionalLossDetails.minimumDuration}
              required
              disabled
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
      ],
    },
    {
      rowProps: {key: 'acc-death-dismemberment-functional-loss-row-2'},
      items: [
        {
          key: propertyPaths.functionalLossDetails.hearingLossAmount,
          element: (
            <QuoteFormElement
              elementType="Text"
              label={isGVA6Plan ? 'Loss of Hearing (Benefit both Ears)' : 'Loss of Hearing (Benefit per Ear)'}
              value={formatCurrencyValue(getQuoteFieldValue(propertyPaths.functionalLossDetails.hearingLossAmount))}
              id={propertyPaths.functionalLossDetails.hearingLossAmount}
              required
              disabled
              adornment="money"
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
        {
          key: propertyPaths.functionalLossDetails.sightLossAmount,
          element: (
            <QuoteFormElement
              elementType="Text"
              label="Loss of Sight (Benefit per Eye)"
              value={formatCurrencyValue(getQuoteFieldValue(propertyPaths.functionalLossDetails.sightLossAmount))}
              id={propertyPaths.functionalLossDetails.sightLossAmount}
              required
              disabled
              adornment="money"
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
      ],
    },
    {
      rowProps: {key: 'acc-death-dismemberment-functional-loss-row-3'},
      items: [
        {
          key: propertyPaths.functionalLossDetails.speechLossAmount,
          element: (
            <QuoteFormElement
              elementType="Text"
              label="Loss of Speech"
              value={formatCurrencyValue(getQuoteFieldValue(propertyPaths.functionalLossDetails.speechLossAmount))}
              id={propertyPaths.functionalLossDetails.speechLossAmount}
              required
              disabled
              adornment="money"
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
        {
          key: propertyPaths.functionalLossDetails.maximumBenefitAmount,
          element: (
            <QuoteFormElement
              elementType="Text"
              label="Maximum Benefit Amount"
              value={formatCurrencyValue(getQuoteFieldValue(propertyPaths.functionalLossDetails.maximumBenefitAmount))}
              id={propertyPaths.functionalLossDetails.maximumBenefitAmount}
              required
              disabled
              adornment="money"
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
      ],
    },
    {
      rowProps: {key: 'acc-death-dismemberment-functional-loss-row-4'},
      items: [
        {
          key: propertyPaths.functionalLossDetails.maxBenefitNumber,
          element: (
            <QuoteFormElement
              elementType="SelectV2"
              dropdownVariant="AttributeValue"
              searchKey="ACCFunctionalLossBenefit.maxBenefitNumber"
              label="Number of Times Maximum Benefit is Payable per Time Period"
              value={getQuoteFieldValue(propertyPaths.functionalLossDetails.maxBenefitNumber)}
              id={propertyPaths.functionalLossDetails.maxBenefitNumber}
              required
              disabled
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
        {
          key: propertyPaths.functionalLossDetails.timePeriodCd,
          element: (
            <QuoteFormElement
              elementType="SelectV2"
              dropdownVariant="AttributeValue"
              searchKey="ACCFunctionalLossBenefit.timePeriodCd"
              label="Time Period"
              value={getQuoteFieldValue(propertyPaths.functionalLossDetails.timePeriodCd)}
              id={propertyPaths.functionalLossDetails.timePeriodCd}
              required
              disabled
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
      ],
    },
  ];
  return <FormRowGrid rows={rows} />;
};

export const AutomobileAccidentalDeath = () => {
  const {selectedPlan} = useSelector((state: ReducerState) => state.quoteForm);
  const {getQuoteFieldValue} = useQuoteField();
  const propertyPaths = deathandDismembermentPath(selectedPlan?.planIndex ?? 0);

  const rows: GridRowProps[] = [
    {
      rowProps: {key: 'acc-death-dismemberment-automobile-accidental-death-row-1'},
      items: [
        {
          key: propertyPaths.automobileAccidentalDeathDetails.incurralPeriod,
          element: (
            <QuoteFormElement
              elementType="Text"
              label="Incurral Period (Days)"
              type="number"
              value={getQuoteFieldValue(propertyPaths.automobileAccidentalDeathDetails.incurralPeriod)}
              id={propertyPaths.automobileAccidentalDeathDetails.incurralPeriod}
              required
              disabled
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
        {
          key: propertyPaths.automobileAccidentalDeathDetails.benefitAmount,
          element: (
            <QuoteFormElement
              elementType="Text"
              label="Benefit Amount"
              value={formatCurrencyValue(
                getQuoteFieldValue(propertyPaths.automobileAccidentalDeathDetails.benefitAmount)
              )}
              id={propertyPaths.automobileAccidentalDeathDetails.benefitAmount}
              required
              disabled
              adornment="money"
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
      ],
    },
  ];

  return <FormRowGrid rows={rows} />;
};

export const AccidentalDeathAndDismembermentBlock = () => {
  const {selectedPlan} = useSelector((state: ReducerState) => state.quoteForm);
  const {getQuoteFieldValue} = useQuoteField();
  const propertyPaths = deathandDismembermentPath(selectedPlan?.planIndex ?? 0);
  const accidentalDeathAndDismembermentSections: ConditionalSection[] = [
    {
      Component: AccidentalDeath,
      key: 'accidentalDeathDetails',
      label: 'Accidental Death',
      disabled: true,
      isApplied: getQuoteFieldValue<boolean>(propertyPaths.isAccidentalDeathApplied),
    },
    {
      Component: AccidentalDeathCommonCarrier,
      key: 'accidentalDeathCommonCarrierDetails',
      label: 'Accidental Death - Common Carrier',
      disabled: true,
      isApplied: getQuoteFieldValue<boolean>(propertyPaths.isAccidentalDeathCommonCarrierApplied),
    },
    {
      Component: AccidentalDismembermemt,
      key: 'accidentalDismembermentDetails',
      label: 'Accidental Dismembermemt',
      disabled: true,
      isApplied: getQuoteFieldValue<boolean>(propertyPaths.isAccidentalDismembermentApplied),
    },
    {
      Component: FunctionalLoss,
      key: 'functionalLossDetails',
      label: 'Functional Loss',
      disabled: true,
      isApplied: getQuoteFieldValue<boolean>(propertyPaths.isFunctionalLossApplied),
    },
    {
      Component: AutomobileAccidentalDeath,
      key: 'automobileAccidentalDeathDetails',
      label: 'Automobile Accidental Death',
      disabled: true,
      hidden: true,
      isApplied: getQuoteFieldValue<boolean>(propertyPaths.isAutomobileAccidentalDeathApplied),
    },
  ];

  return (
    <FormWrapper title="Accidental Death and Dismemberment" collapsible withSeparator>
      <Grid container direction="column">
        <AccidentalDeathAndDismembermentUnits />
        <QuoteFormConditionalSection sections={accidentalDeathAndDismembermentSections} />
      </Grid>
    </FormWrapper>
  );
};
